import { NextApiRequest, NextApiResponse } from 'next'
import { parse } from 'url'
import { createSellers } from './data'

const MOCK_SELLERS = createSellers(2000)

export async function handleSellersMock(
  req: NextApiRequest,
  res: NextApiResponse
) {
  // Parse da URL para extrair os query params
  const { query } = parse(req.url || '', true)

  let filteredSellers = [...MOCK_SELLERS]

  // Aplicar filtros baseados nos query params
  if (query.keyword) {
    const keyword = String(query.keyword).toLowerCase()
    filteredSellers = filteredSellers.filter(
      (seller) =>
        seller.id.toLowerCase().includes(keyword) ||
        seller.name.toLowerCase().includes(keyword)
    )
  }

  if (query.integration) {
    filteredSellers = filteredSellers.filter(
      (seller) => seller.integration === query.integration
    )
  }

  if (query.isActive !== undefined) {
    const isActive = query.isActive === 'true'
    filteredSellers = filteredSellers.filter(
      (seller) => seller.isActive === isActive
    )
  }

  if (query.isBetterScope !== undefined) {
    const isBetterScope = query.isBetterScope === 'true'
    filteredSellers = filteredSellers.filter(
      (seller) => seller.isBetterScope === isBetterScope
    )
  }

  if (query.isVtex !== undefined) {
    const isVtex = query.isVtex === 'true'
    filteredSellers = filteredSellers.filter(
      (seller) => seller.isVtex === isVtex
    )
  }

  if (query.sellerType) {
    const sellerType = parseInt(String(query.sellerType), 10)
    filteredSellers = filteredSellers.filter(
      (seller) => seller.sellerType === sellerType
    )
  }

  // Aplicar sorting se especificado
  if (query.sort) {
    const [sortField, sortOrder] = String(query.sort).split(',')
    const isDesc = sortOrder === 'desc'

    if (sortField === 'name') {
      filteredSellers.sort((a, b) => {
        const comparison = a.name.localeCompare(b.name)
        return isDesc ? -comparison : comparison
      })
    }
  }

  // Aplicar paginação
  const from = query.from ? parseInt(String(query.from), 10) : 0
  const to = query.to
    ? parseInt(String(query.to), 10)
    : Math.min(from + 100, filteredSellers.length)

  const paginatedSellers = filteredSellers.slice(from, to)

  // Retornar a resposta mockada
  return res.status(200).json({
    items: paginatedSellers,
    paging: {
      total: filteredSellers.length,
      pages: Math.ceil(filteredSellers.length / 100),
      currentPage: Math.floor(from / 100) + 1,
      perPage: 100,
    },
  })
}
